/** Define all validation rules separated by feature */
export namespace InputFormatEnum {
  export const date = Object.freeze({
    format: 'DD/MM/YYYY',
  });

}
